import axios from 'axios';

const API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

if (!API_KEY) {
  console.error('VITE_GOOGLE_MAPS_API_KEY is not configured');
}

export class GoogleMapsService {
  static async getCurrentLocation(): Promise<{ lat: number; lng: number }> {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('Geolocation is not supported by your browser'));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
        },
        (error) => {
          let errorMessage = 'Failed to get your location';
          switch (error.code) {
            case error.PERMISSION_DENIED:
              errorMessage = 'Location permission denied';
              break;
            case error.POSITION_UNAVAILABLE:
              errorMessage = 'Location information unavailable';
              break;
            case error.TIMEOUT:
              errorMessage = 'Location request timeout';
              break;
          }
          reject(new Error(errorMessage));
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    });
  }

  static getGoogleMapsUrl(cafe: { placeId: string; location: { lat: number; lng: number } }) {
    if (!cafe.placeId) {
      return `https://www.google.com/maps/search/?api=1&query=${cafe.location.lat},${cafe.location.lng}`;
    }
    return `https://www.google.com/maps/place/?q=place_id:${cafe.placeId}`;
  }

  static getStaticMapUrl(
    center: { lat: number; lng: number },
    markers: Array<{ lat: number; lng: number; color?: string }> = [],
    zoom: number = 14,
    size: string = '600x300'
  ) {
    if (!API_KEY) return '';
    
    let url = `https://maps.googleapis.com/maps/api/staticmap?center=${center.lat},${center.lng}&zoom=${zoom}&size=${size}&key=${API_KEY}`;
    
    markers.forEach(marker => {
      const color = marker.color || 'red';
      url += `&markers=color:${color}|${marker.lat},${marker.lng}`;
    });
    
    return url;
  }
}